/**
 * Region → public Connect telemetry + softphone TurnNlb hosts.
 * Sourced from Amazon Connect Endpoint Test Utility v2.18.0 (tools.connect.aws).
 */

export type ConnectRegionConfig = {
  code: string
  name: string
  latencyEndpoint: string
  mediaEndpoints: string[]
}

export const CONNECT_REGIONS: ConnectRegionConfig[] = [
  {
    code: 'us-east-1',
    name: 'N. Virginia',
    latencyEndpoint: 'https://ieluqbvv.telemetry.connect.us-east-1.amazonaws.com',
    mediaEndpoints: [
      'turnnlb-d76454ac48d20c1e.elb.us-east-1.amazonaws.com',
      'turnnlb-31a7fe8a79c27929.elb.us-east-1.amazonaws.com',
      'turnnlb-7a9b8e750cec315a.elb.us-east-1.amazonaws.com',
    ],
  },
  {
    code: 'us-west-2',
    name: 'Oregon',
    latencyEndpoint: 'https://ieluqbvv.telemetry.connect.us-west-2.amazonaws.com',
    mediaEndpoints: [
      'turnnlb-8d79b4466d82ad0e.elb.us-west-2.amazonaws.com',
      'turnnlb-dbc4ebb71307fda2.elb.us-west-2.amazonaws.com',
      'turnnlb-13c884fe3673ed9f.elb.us-west-2.amazonaws.com',
    ],
  },
]

/** Adastra Connect instances are in us-east-1 across sandbox / QAS / PRD. */
export const DEFAULT_DIAGNOSTIC_REGIONS = ['us-east-1'] as const

export const getRegionForCode = (code: string): ConnectRegionConfig | undefined =>
  CONNECT_REGIONS.find((region) => region.code === code)
